// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb7b84bd","726":"8c11f7b5"}[chunkId] + ".chunk.js";
};